import { useRef, useEffect } from 'react';
import { DEFAULT_SCROLL_DELAY } from '../constants';
/**
 * Хук отвечает за автоскролл к заголовку последнего активного айтема, если тот
 * скрылся за пределы экрана при его открытии/закрытии.
 */
export var useAutoScrollToLastActive = function useAutoScrollToLastActive(_ref) {
  var accordionItemsRef = _ref.accordionItemsRef,
    _ref$scrollDelay = _ref.scrollDelay,
    scrollDelay = _ref$scrollDelay === void 0 ? DEFAULT_SCROLL_DELAY : _ref$scrollDelay;
  var timer = useRef(null);
  useEffect(function () {
    return function () {
      if (timer.current) {
        clearTimeout(timer.current);
        timer.current = null;
      }
    };
  }, [timer]);
  var scrollToLastActive = function scrollToLastActive(lastActiveIndex) {
    timer.current = setTimeout(function () {
      var activeElement = accordionItemsRef.current[lastActiveIndex];
      var topPotision = activeElement.getBoundingClientRect().top;
      var isTopHidden = topPotision < 0;
      if (isTopHidden) {
        activeElement.scrollIntoView({
          block: 'start',
          behavior: 'smooth'
        });
      }
    }, scrollDelay);
  };
  return {
    scrollToLastActive: scrollToLastActive
  };
};